<template>
  <div class="lime-footer">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
              <span class="footer-text">2020 © Ghost Inc.</span>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'FooterMain'
  }
</script>




// WEBPACK FOOTER //
// src/components/FooterMain.vue